<template>
    <div>
        <div class="my-5"></div>
        <!-- section on1 -->
        <section style="background-color: #f7f4ff;">
            <div class="container my-5 ">
                <div class="row my-5 p-2">
                    <div class="col-md-6 py-3 mt-5">
                        <div class="d-flex flex-column align-items-start">
                            <h1 class="header mb-4">Partner with a highly trusted brand in international
                                education</h1>
                            <!-- <h1 class="display-2 display-md-4">Partner with a highly trusted brand in international education</h1> -->
                            <p class="mx-2 mb-3">Own a consulting franchise for a brand with 20+ years of experience and a
                                network of 750+ global institutes.</p>
                            <div class="d-flex justify-content-start mb-5">
                                <button class="btn btn-outline-primary mr-2">Learn More</button>
                                <button class="btn btn-outline-primary">Enquire</button>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="d-flex flex-column align-items-center">
                            <img src="@/assets/imgs/franchise/ss.png" class="img-fluid mt-5 p-5" alt="Image 1" />
                        </div>
                    </div>
                </div>
            </div>
        </section>



        <!-- section three -->
        <section>
            <div class="container p-5">
                <h2 class="header my-5 mb-5 text-center">Why Aliff Franchise?</h2>

                <div class="container text-center">
                    <div class="row mb-3">
                        <div class="col-md-4">
                            <div class="value-box">
                                <h4 class="mb-3">Trusted Brand</h4>
                                <p>20+ Years of Excellence in the study abroad industry. A Pioneer in quality Admission &
                                    Visa Counselling</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="value-box">
                                <h4 class="mb-3">High Returns</h4>
                                <p>Best Commission rates with transparent payment process Lorem ipsum dolor sit.</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="value-box">
                                <h4 class="mb-3">Comprehensive Network</h4>
                                <p>Partnered with 750+ Global Universities across the globe with access to 90,000+ programs
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="value-box">
                                <h4 class="mb-3">Brand Presence</h4>
                                <p>Strong network of 46+ centers globally Lorem ipsum, dolor sit amet consectetur
                                    adipisicing elit.</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="value-box">
                                <h4 class="mb-3">Team of Experts</h4>
                                <p>In-depth experience for destinations like USA, Canada, UK, Australia / New Zealand,
                                    Europe, Singapore & Dubai</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="value-box">
                                <h4 class="mb-3">University Events</h4>
                                <p>Regular large-scale education fair</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </section>
        <!-- section two  -->
        <section class="container my-4 ">
            <h2 class="header text-center mb-5">Numbers backing us</h2>
            <div class="container">
                <div class="row p-5 mb-5 text-center" style="background-color: #090841; color: white; border-radius: 20px;">

                    <div class="col-md-4">
                        <div class="info-box">
                            <h2 class="display-4">460+</h2>
                            <p>Tie ups with Global Universities</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="info-box">
                            <h2 class="display-4">32+ <span>Crore</span></h2>
                            <p>Scholarships Awarded</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="info-box">
                            <h2 class="display-4">25,000+</h2>
                            <p>Students Worldwide</p>
                        </div>
                    </div>
                </div>

            </div>
        </section>

        <!-- section three carousel -->
        <section style="background-color: #f7f4ff;">
            <div class="container mt-5">
                <h2 class="header p-5 text-center">Feel the Aliff Branch Privileges</h2>

                <div class="row">
                    <!-- Carousel on the left -->
                    <div class="col container mb-5 w-80 justify-content-center">
                        <div>
                            <b-carousel id="carouselExample" controls indicators>
                                <b-carousel-slide v-for="(item, index) in carouselItems" :key="index" :img-src="item.image">
                                    <p>{{ item.text }}</p>
                                </b-carousel-slide>
                            </b-carousel>
                        </div>
                    </div>

                    <!-- Content on the right -->
                    <div class="col-md-12 mt-3 text-center">

                        <div>
                            <div class="row mb-3 ">
                                <div class="col-md-6">
                                    <h4>Expert Led Training</h4>
                                    <p>Exclusive training for your staff conducted by industry experts at the Aliff Head
                                        Office
                                    </p>
                                </div>
                                <div class="col-md-6">
                                    <h4>Marketing</h4>
                                    <p>Targeted marketing campaigns and strategy development to attract leads</p>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-6">
                                    <h4>Staffing</h4>
                                    <p>Streamlined support in staffing and training</p>
                                </div>
                                <div class="col-md-6">
                                    <h4>Tech Tools</h4>
                                    <p>Exclusive access to data-driven platform customized for efficient daily operations
                                    </p>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-md-6">
                                    <h4>Global Events</h4>
                                    <p>Opportunity to participate in events, fairs, and webinars involving Universities
                                        across
                                        the globe.</p>
                                </div>
                                <div class="col-md-6">
                                    <h4>Easy Loan Assistance</h4>
                                    <p>Assistance in Students Education Loan via Leap finance</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- section four -->
        <section>
            <div class="container mt-5">
                <div>
                    <b-tabs id="partner-tabs" card>
                        <!-- Tab 1 -->
                        <b-tab>
                            <template #title>
                                <div class="custom-tab-title">
                                    Lorem, ipsum.
                                </div>
                            </template>
                            <!-- Content for Partner Portal tab -->
                            <div class="d-flex justify-content-center align-items-center">
                                <img src="@/assets/imgs/franchise/test.png" class="img-fluid mt-2 p-1 border"
                                    alt="Image 1" />
                            </div>

                        </b-tab>

                        <!-- Tab 2 -->
                        <b-tab>
                            <template #title>
                                <div class="custom-tab-title">
                                    Lorem, ipsum.
                                </div>
                            </template>
                            <!-- Content for Chat Support tab -->
                            <p>Constant chat support to increase process efficiency for partners</p>
                        </b-tab>

                        <!-- Tab 3 -->
                        <b-tab>
                            <template #title>
                                <div class="custom-tab-title">
                                    Lorem, ipsum.
                                </div>
                            </template>
                            <!-- Content for Course Finder tab -->
                            <p>Instant chat support to increase process efficiency for partners</p>
                        </b-tab>

                        <!-- Tab 4 -->
                        <b-tab>
                            <template #title>
                                <div class="custom-tab-title">
                                    Lorem, ipsum. </div>
                            </template>
                            <!-- Content for Education Loan tab -->
                            <p>Hassle-free education loan processing</p>
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
        </section>

        <!-- section five -->
        <section>
            <div class="container my-5 p-3">
                <div class="row my-3">


                    <div class="col-md-6">
                        <div class="d-flex justify-content-center align-items-center">
                            <img src="@/assets/imgs/franchise/ss.png" class="img-fluid mt-5 p-5" alt="Image 1" />
                        </div>

                    </div>
                    <div class="col-md-6 py-3 mt-5">
                        <div class="d-flex flex-column align-items-start">
                            <h2 class="header mb-5">How Partnering with Aliff adds Value to your Business</h2>
                            <div class="container">
                                <div class="content-item">
                                    <h4>- Brand Value</h4>
                                    <p>Associate with a trusted brand with 20+ years of experience</p>
                                </div>
                                <div class="content-item">
                                    <h4>- Recognition</h4>
                                    <p>Participate in Exclusive Global Events & Fairs to improve visibility</p>
                                </div>
                                <div class="content-item">
                                    <h4>- Support</h4>
                                    <p>Dedicated SPOC Helpline enhances operational efficiency</p>
                                </div>
                                <div class="content-item">
                                    <h4>- Customised Solutions</h4>
                                    <p>Access to software to streamline lead and application management</p>
                                </div>
                                <div class="content-item">
                                    <h4>- Personalized Support</h4>
                                    <p>Support with business metrics, trends, and insights to scale your business</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- section six -->
        <section class="p-5">
            <div>
                <h2 class="text-center header mb-5">What we look for in Franchise Partners</h2>
                <div class="container">
                    <div class="row">
                        <!-- Card 1 -->
                        <div class="col-md-4">
                            <div class="custom-card">
                                <h3 class="text-center">Experience</h3>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae, quod!</p>
                            </div>
                        </div>
                        <!-- Card 2 -->
                        <div class="col-md-4">
                            <div class="custom-card">
                                <h3 class="text-center">Financial Resources</h3>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae, quod!</p>
                            </div>
                        </div>
                        <!-- Card 3 -->
                        <div class="col-md-4">
                            <div class="custom-card">
                                <h3 class="text-center">Skills</h3>

                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae, quod!</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <!-- Card 4 -->
                        <div class="col-md-4">
                            <div class="custom-card">
                                <h3 class="text-center">Commitment</h3>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae, quod!</p>
                            </div>
                        </div>
                        <!-- Card 5 -->
                        <div class="col-md-4">
                            <div class="custom-card">
                                <h3 class="text-center">Aliff Vision Match</h3>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae, quod!</p>
                            </div>
                        </div>
                        <!-- Card 6 -->
                        <div class="col-md-4">
                            <div class="custom-card">
                                <h3 class="text-center">Ambition</h3>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae, quod!</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
        <!-- section university -->

        <section class="container">
            <div class="p-5">
                <h2 class="text-center header mb-5">Testimonial</h2>
                <div class="container p-3" style="background-color: #f7f4ff; border-radius: 10px;">
                    <h2>"Lorem ipsum dolor sit amet consectetur, adipisicing elit. Assumenda debitis est quis praesentium,
                        neque aspernatur rem itaque perferendis reiciendis at, libero ipsa, ea incidunt facere labore! Dolor
                        optio quidem consequatur."</h2>
                    <p>John Doe</p>
                </div>
            </div>


        </section>

        <!-- section seven -->
        <section class="container">
            <div>
                <h2 class="text-center header mb-2">Our Top Partner Universities</h2>
                <p class="text-center mb-5">A showcase of Aliff’s Network and Trust built of X years</p>
                <template>
                    <div>
                        <b-tabs id="partner-tabs" card>
                            <!-- Tab 1 -->
                            <b-tab>
                                <template #title>
                                    <div class="custom-tab-button">
                                        India
                                    </div>
                                </template>
                                <!-- Content for Partner Portal tab -->
                                <div class="tab-content">
                                    <img src="placeholder-image1.jpg" alt="Placeholder Image 1" />
                                </div>
                            </b-tab>

                            <!-- Tab 2 -->
                            <b-tab>
                                <template #title>
                                    <div class="custom-tab-button">
                                        Dubai
                                    </div>
                                </template>
                                <!-- Content for Chat Support tab -->
                                <div class="tab-content">
                                    <img src="placeholder-image2.jpg" alt="Placeholder Image 2" />
                                </div>
                            </b-tab>

                            <!-- Tab 3 -->
                            <b-tab>
                                <template #title>
                                    <div class="custom-tab-button">
                                        Kuwait
                                    </div>
                                </template>
                                <!-- Content for Course Finder tab -->
                                <div class="tab-content">
                                    <img src="placeholder-image3.jpg" alt="Placeholder Image 3" />
                                </div>
                            </b-tab>


                        </b-tabs>
                    </div>
                </template>
            </div>

        </section>

        <!-- section nine -->
        <section class="mb-5 p-5 mt-5" style="background-color: #f7f4ff;">

            <div class="container p-3" style="background-color: #090841; color: #f7f4ff; border-radius: 10px;">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8">
                            <h1>Invest in a franchise opportunity for rapid business growth and lucrative returns</h1>
                        </div>
                        <div class="col-md-4 d-flex align-items-center justify-content-end">
                            <button class="btn btn-primary mr-2 text-white">Learn More</button>
                            <button class="btn btn-primary text-white">Enquire</button>
                        </div>
                    </div>
                </div>

            </div>
        </section>





    </div>
</template>


<script>
export default {
    data() {
        return {
            carouselItems: [
                {
                    image: 'https://via.placeholder.com/600x400',
                    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                },
                {
                    image: 'https://via.placeholder.com/600x400',
                    text: 'Slide 2: Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                },
                {
                    image: 'https://via.placeholder.com/600x400',
                    text: 'Slide 3: Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                },
                {
                    image: 'https://via.placeholder.com/600x400',
                    text: 'Slide 4: Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                },
            ],
        };
    },
};
</script>

<style scoped>
.carousel-card {
    background-color: #000;
    color: #fff;
    border-radius: 10px;
    padding: 20px;
    text-align: center;
}

.card-content {
    padding: 20px;
}

/* Customize carousel control styles if needed */
.carousel-control-prev-icon,
.carousel-control-next-icon {
    background-color: #000;
    border-radius: 50%;
}

.carousel-control-prev,
.carousel-control-next {
    background-color: rgba(0, 0, 0, 0.5);
}

.carousel-control-prev:hover,
.carousel-control-next:hover {
    background-color: rgba(0, 0, 0, 0.8);
}

/* uni */

.custom-tab-button {
    background-color: #090841;
    color: #fff;
    padding: 10px 20px;
    cursor: pointer;
    border: none;
    border-radius: 5px;
    font-weight: bold;
}

.custom-tab-button:hover {
    background-color: #0056b3;
}

.tab-content img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
}

/* uni */
.header {
    font-family: "Fira Sans", sans-serif;
    font-weight: 500;
    font-size: 40px;
    /* line-height: 34px; */
    transition: all 0.5s ease-in;

}

.custom-tab-title {
    width: 100%;
    text-align: center;
    background-color: #090841;
    color: white;
    padding: 10px;
    border-radius: 10px 10px 0 0;
    /* Rounded top corners */
    cursor: pointer;
}

.custom-tab-title:hover {
    background-color: #292390;
    /* Darker background on hover */
}

.custom-card {
    background-color: #eeedff;
    /* color: white; */
    padding: 20px;
    border-radius: 5px;
    margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Franchise.vue